export default [
    {
        name: 'instituto data science',
        url: '/centros_pdf/Ficha_IDS_UDD.pdf'
    },
    {
        name: 'centro de apego y regulación emocional',
        url: '/centros_pdf/Ficha_CARE_UDD.pdf'
    },
    {
        name: 'centro de investigación en sustentabilidad y gestión estratégica de recursos',
        url: '/centros_pdf/Ficha_CISGER_UDD.pdf'
    },
    {
        name: 'centro de investigación y mejoramiento de la educación',
        url: '/centros_pdf/Ficha_CIME_UDD.pdf'
    },
    {
        name: 'centro de investigación de la complejidad social',
        url: '/centros_pdf/Ficha_CICS.pdf'
    },
    {
        name: 'centro de estudios en bienestar y convivencia social',
        url: '/centros_pdf/Ficha_CEBCS_UDD.pdf'
    },
    {
        name: 'Centro De Estudios En Economía Y Negocios',
        url: '/centros_pdf/Ficha_CEEN_UDD.pdf'
    }
]